import { render, staticRenderFns } from "./AssetWarning.vue?vue&type=template&id=66a4b512"
import script from "./AssetWarning.vue?vue&type=script&lang=ts"
export * from "./AssetWarning.vue?vue&type=script&lang=ts"
import style0 from "./AssetWarning.vue?vue&type=style&index=0&id=66a4b512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports